import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AutocompleteOption } from '@dxb-web-ui-framework/design-system';

export enum ValueIdentifier {
  DEBIT_ACCOUNT_NUMBER = 'debitAccountNumber',
  CREDIT_ACCOUNT_NUMBER = 'creditAccountNumber',
  ORDER_CURRENCY = 'orderCurrency',
  CREDIT_ACCOUNT_TYPE = 'creditAccountType',
  ORDER_AMOUNT = 'orderAmount',
  TRANSFER_TYPE = 'transferType',
  RECEIVER_COMMENTS = 'receiverComments',
  CHARGING_METHOD = 'chargingMethod',
  RECEIVER_FULL_NAME = 'receiverFullName',
  RECEIVER_ADDRESS = 'receiverAddress',
  RECEIVER_COUNTRY = 'receiverCountry',
  RECEIVER_CITY = 'receiverCity',
  UPLOADED_DOCS = 'uploadedDocs',
  PRIORITY = 'priority',
  NORMAL = 'normal',
  IMMEDIATE = 'immediate',
  RECEIVER_BIC = 'receiverBic',
  BANK_NAME = 'bankName',
  BANK_COUNTRY = 'bankCountry',
  BANK_DETAILS = 'bankDetails',
  BANK_CITY = 'bankCity',
  RECEIVER_SORT_CODE = 'receiverSortCode',
  BOP_CODE = 'bopCode',
  COR = 'cor',
  BIK = 'bik',
  INN = 'inn',
  KPP = 'kpp',
  VO = 'vo',
  BIC = 'bic',
}

export enum CreditAccountTypes {
  ECOMMBX_ACCOUNT = 'ECOMMBX_ACCOUNT',
  EXTERNAL_ACCOUNT = 'EXTERNAL_ACCOUNT',
}

export enum SelectFundTransferFormActiveTabs {
  OWN_ACCOUNTS = '0',
  SAVED_BENEFICIARIES = '1',
}

export type ForeCastFormData = {
  debitAccountNumber?: string;
  creditAccountNumber?: string;
  orderAmount?: string;
  orderCurrency?: string;
  chargingMethod?: number;
  normal?: boolean | string | Date;
  receiverComments?: string;
  priority?: string;
  receiverAddress?: string;
  receiverFullName?: string;
  uploadedDocs?: File[] | [];
  bankCountry?: string | AutocompleteOption;
  receiverCountry?: AutocompleteOption;
  bankCity?: string;
  bankName?: string;
  swiftAddress?: string;
  receiverBic?: string;
  receiverSortCode?: string;
  receiverCity?: string;
  bopCode?: AutocompleteOption;
  cor?: string;
  bik?: string;
  inn?: string;
  kpp?: string;
  vo?: AutocompleteOption;
};

export enum StepIdentifiers {
  FILL_OUT = 'FILL_OUT',
  SUCCESS = 'SUCCESS',
}

export type UnknownBankDetails = Nullable<{
  bankCountry: Nullable<AutocompleteOption>;
  bankCity: Nullable<AutocompleteOption>;
  bankName: Nullable<AutocompleteOption>;
}>;
